import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import Modal from '../../../../FlyfishComponents/Modal';
import Axios from 'axios';
import { loadStateSession } from '../../../../FlyfishComponents/flyfishutils/utils';
import Button from '../../../../FlyfishComponents/Button';
import { MicEcom } from '../../../../FlyfishComponents/flyfishIcons/icons';
import { getImg } from '../../../../../Utils/getImg';
import Loader from '../../EcomSearch/LoaderCard/lotties-for-loaders/loader.json';
import lottieLight from 'lottie-web/build/player/lottie_light.min.js';
import Input from '../../../../FlyfishComponents/Input';
const UploadModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	padding: 24px;
	padding-top: 0px;
	.ff-chatbot-h6 {
		color: var(--primary-color-ff-primary900);
	}
	.ff-chatbot-body1 {
		color: var(--primary-color-ff-primary900);
		margin-top: 24px;
		text-align: center;
	}
	img:not(.dropped-image) {
		width: 45%;
	}
	.dropped-image {
		aspect-ratio: 1;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
	.ff-drag-drop {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #f9f5ff;
		border: 1px solid var(--black-10);
		width: 100%;
		border-radius: 12px;
		margin-top: 24px;
		padding: 24px;
		height: 321px;
		width: 724px;
		// min-height: ${(props) => (props.loader ? '' : '273px')};
		&.dragging {
			border: 2px dashed var(--primary-color-ff-primary500);
			cursor: copy;
		}
		.ff-drag-text {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.ff-border {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 10px;
			> div {
				&:nth-of-type(1) {
					width: 50%;
					border-top: 1px solid rgba(0, 0, 0, 0.1);
				}
				&:nth-of-type(3) {
					width: 50%;
					border-top: 1px solid rgba(0, 0, 0, 0.1);
				}
			}
		}
		.ff-upload-input {
			width: 100%;
			.ff-input {
				max-width: unset;
				padding: unset;
				.MuiInputBase-root {
					background-color: #fff;
				}
			}
		}

		.ff-chatbot-h5 {
			color: rgba(140, 94, 234, 1);
			font-weight: normal;
		}
		& .custom-button {
			& > button {
				background-color: var(--primary-color-ff-primary600) !important;
			}
		}
	}
	.image-upload-button-holder {
		display: flex;
		margin-top: 20px;
		align-items: baseline;
		gap: 10px;
		width: 100%;
		& > .custom-button {
			position: relative;
			top: 5px;
			& > button {
				background-color: #9aa8b4 !important;
				opacity: 1 !important;
				font-weight: 600;
				font-family: var(--fontFamily);
				border-radius: 100px;
				font-size: 14px;
				letter-spacing: 0.56px;
			}
		}
		&.colorChange {
			& > .custom-button {
				& > button {
					background-color: var(--primary-color-ff-primary600) !important;
				}
			}
		}
	}
`;
const ModalContent = styled.div`
	.modal-overlay-bot .modal-container-bot {
		width: fit-content;
		height: fit-content;
		border-radius: 20px;
		position: relative;
		> .body {
			padding: 24px;
		}
		header {
			.top-close {
				position: absolute;
				right: 15px;
			}
		}
	}
`;
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
	display: inline-block;
	animation: ${spin} 1s linear infinite;
`;
type Props = {
	messageId;
	conversationId;
	onClose;
	botId;
	tenantId;
	uploadImageResp;
	clearFilter;
};
const UploadImageDesktop = ({
	messageId,
	conversationId,
	onClose,
	botId,
	tenantId,
	uploadImageResp,
	clearFilter
}: Props) => {
	const [image, setImage] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [imgUrl, setImgUrl] = useState('');
	const [error, setError] = useState('');
	const [urlValidation, setUrlValidation] = useState('');
	const [result, setResult] = useState(null);
	const [loader, setLoader] = useState(false);
	const fileReImportRef = useRef(null);
	const handleDragOver = (e) => {
		e.preventDefault();
		setIsDragging(true);
		setImage(null);
	};

	const handleDragLeave = () => {
		setIsDragging(false);
	};

	const handleDrop = (e) => {
		let result64;
		setImage(null);
		e.preventDefault();
		setIsDragging(false);
		const maxSize = 5 * 1024 * 1024;
		const files = e.dataTransfer.files;
		const acceptedFormats = [
			'image/jpeg',
			'image/png',
			'image/tiff',
			'image/webp',
			'image/bmp',
		];
		if (files && files[0]) {
			const reader = new FileReader();

			if (!acceptedFormats.includes(files[0].type)) {
				setError(
					'Couldn’t upload the image. Please ensure that your image is in .jpg, .png, .tif, .webp or .bmp format.'
				);
				setImage(null);
				return;
			}
			if (files[0].size > maxSize) {
				setError(
					'Couldn’t upload the image. Please ensure that your image is less than 5MB in size'
				);
				return;
			} else {
			}

			setError('');

			reader.onload = (e) => {
				setResult(e.target.result);
				setImage(e.target.result);
				handleAPI(e.target.result);
			};
			reader.readAsDataURL(files[0]);
		}
	};

	const validateURL = (url) => {
		const imageUrlRegex =
			/^https:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(:\d+)?(\/.*\.(jpg|jpeg|png|gif|bmp|webp))(?:\?.*)?$/; //|gif|bmp|webp
		if (!imageUrlRegex.test(url)) {
			setUrlValidation('Please enter a valid URL');
			return;
		} else {
			handleAPI();
		}
	};
	const handleAPI = (bas64?) => {
		let payload = {
			messageId: messageId,
			id: conversationId,
			botId: botId,
			version: 'prod',
			image_link: imgUrl.trim(),
			image_base64: bas64
				? bas64.split(',')[1]
				: result && result.split(',')[1],
		};
		setLoader(true);
		clearFilter()
		Axios.post(`${window['BASE_URL']}/conversation/image`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'x-tenant-id': tenantId,
				'Authorization': `Bearer ${loadStateSession('token')}`
			},
		})
			.then((resp) => {
				if (resp.status >= 500 && resp.status < 600) {
					throw new Error('failed to fetch');
				}
				setLoader(false);
				uploadImageResp(resp.data);
			})
			.catch((error) => {
				setLoader(false);

				let offlineMessage = 'Something went wrong please try after sometime';

				if (error.message) {
					offlineMessage = error.message;
					if (error.message.toLowerCase() === 'failed to fetch') {
						offlineMessage = `Couldn't connect to the server. Please retry. If the issue persists, check your connection and try again later.`;
					}
				}

				if (!navigator.onLine) {
					setError(`Seems like you are not connected to a network.`);
				} else {
					setError(offlineMessage);
				}
			});
	};
	const handleFileSelect = (e) => {
		if (fileReImportRef.current) {
			let fileInput = fileReImportRef.current;
			var filePath = fileInput.value;
			setImage(filePath);
		}
		e.preventDefault();
		const maxSize = 5 * 1024 * 1024; // 5 MB
		const acceptedFormats = [
			'image/jpeg',
			'image/png',
			'image/tiff',
			'image/webp',
			'image/bmp',
		];
		const files = e.target.files || e.dataTransfer.files;

		if (files && files[0]) {
			const file = files[0];

			if (!acceptedFormats.includes(file.type)) {
				setError(
					`Couldn't upload the image. Please ensure that your image is in .jpg, .png, .tif, .webp or .bmp format.`
				);
				setImage(null);
				return;
			}
			if (file.size > maxSize) {
				setError(
					`Couldn't upload the image. Please ensure that your image is less than 5MB in size.`
				);
				setImage(null);
				return;
			}

			setError('');
			const reader = new FileReader();
			reader.onload = (e) => {
				setResult(e.target.result);
				setImage(e.target.result);
				handleAPI(e.target.result);
			};
			reader.readAsDataURL(file);
		}
	};

	return (
		<ModalContent className='ff-upload-content'>
			<Modal
				headerCloseBtn
				footerNotReq={true}
				onClose={onClose}
				headerCloseBtnIcon={
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='29.255'
						height='29.25'
						viewBox='0 0 29.255 29.25'
					>
						<g
							id='Icon_ion-ios-close-outline'
							data-name='Icon ion-ios-close-outline'
							transform='translate(-3.372 -3.375)'
						>
							<path
								id='Path_20510'
								data-name='Path 20510'
								d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
							/>
							<path
								id='Path_20511'
								data-name='Path 20511'
								d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
							/>
						</g>
					</svg>
				}
			>
				<UploadModalWrapper loader={loader}>
					<div className='ff-chatbot-h6 '>Search with image</div>
					<div className='ff-chatbot-body1'>
						Upload a pic of any product and we will find similar products for
						you
					</div>

					{loader ? (
						<div className='ff-drag-drop'>
							<LoaderWrapper>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g id='loader'>
										<path
											id='Subtract'
											d='M19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 7.71979 7.71979 4.25 12 4.25V2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12H19.75Z'
											fill='var(--primary-color-ff-primary500)'
										/>
									</g>
								</svg>
							</LoaderWrapper>

							<div
								className='ff-chatbot-body1'
								style={{
									color: 'var(--primary-color-ff-primary500)',
									marginTop: '4px',
								}}
							>
								Uploading
							</div>
						</div>
					) : (
						<div
							className={`ff-drag-drop ${isDragging ? 'dragging' : ''}`}
							onDragOver={handleDragOver}
							onDragLeave={handleDragLeave}
							onDrop={handleDrop}
						>
							{image && error.length === 0 ? (
								<img src={image} alt='Dropped' className='dropped-image' />
							) : isDragging || (error && error.length > 0) ? (
								error.length > 0 ? (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											justifyContent: 'center',
											alignItems: 'center',
										}}
									>
										<svg
											width={48}
											height={48}
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<path
												d='M24 4C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4Zm2 30h-4v-4h4v4Zm0-8h-4V14h4v12Z'
												fill='#FB5C53'
											/>
										</svg>
										<div
											className='ff-chatbot-body2'
											style={{
												color: 'rgba(89, 99, 109, 1)',
												marginTop: '8px',
												marginBottom: '20px',
											}}
										>
											{error}
										</div>
										<Button
											onClick={() => {
												setError('');
												setImage('');
											}}
										>
											Try again
										</Button>
									</div>
								) : (
									<div className='ff-chatbot-h5'>Drop your image here</div>
								)
							) : (
								!image && (
									<div className='ff-drag-text'>
										<img
											src={getImg('upload-image-seach.webp')}
											draggable='false'
										/>
										<div
											className='ff-chatbot-body1'
											style={{
												color: 'var(--primary-color-ff-primary900)',
												marginTop: '4px',
											}}
										>
											Drag an image here or{' '}
											<label
												htmlFor='import-media-file'
												style={{
													color: 'var(--primary-color-ff-primary600)',
													borderBottom:
														'1px solid var(--primary-color-ff-primary600)',
													cursor: 'pointer',
												}}
											>
												choose one
											</label>
											<input
												ref={fileReImportRef}
												id='import-media-file'
												style={{ display: 'none' }}
												className='input-file'
												type='file'
												accept='image/jpeg, image/png, image/tiff, image/webp, image/bmp'
												onChange={(event) => {
													handleFileSelect(event);
												}}
											/>
										</div>
									</div>
								)
							)}
							{!isDragging && !image && !error && error.length == 0 && (
								<>
									<div className='ff-border'>
										<div></div>
										<div
											className='ff-chatbot-body2'
											style={{ marginLeft: '10px', marginRight: '10px' }}
										>
											OR
										</div>
										<div></div>
									</div>
									<div
										className={`image-upload-button-holder ${imgUrl.length ? 'colorChange' : ''
											}`}
									>
										<Input
											className='ff-upload-input'
											onChange={(ev) => {
												setImgUrl(ev.target.value);
												setUrlValidation('');
											}}
											value={imgUrl}
											placeholder='Paste image link'
											error={urlValidation.length > 0 ? true : false}
											errorText={urlValidation}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													validateURL(imgUrl);
												}
											}}
										/>
										<Button
											size='small'
											disabled={imgUrl.length ? false : true}
											onClick={() => {
												validateURL(imgUrl);
											}}
										>
											Upload
										</Button>
									</div>
								</>
							)}
						</div>
					)}
				</UploadModalWrapper>
			</Modal>
		</ModalContent>
	);
};

export default UploadImageDesktop;
